import React from "react";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { COLORS } from "../../../styles/uiConstants";
import { listHeadCellSx } from "./listStyles";
import ListLoadingOverlay from "./ListLoadingOverlay";

/**
 * Liste yüklenirken gösterilen iskele: masaüstünde iskelet tablo satırları,
 * mobilde iskelet kartlar. Üstünde her zaman ListLoadingOverlay durur.
 *
 * @param {Array<{label: string, key?: string, width?: string|number}>} columns
 */
export default function ListSkeleton({
  columns = [],
  rowCount = 8,
  mobileCardCount = 4,
  message,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ position: "relative", height: "100%", overflow: "hidden" }}>
      <Box sx={{ height: "100%", opacity: 0.4, pointerEvents: "none", overflow: "hidden" }}>
        {isMobile ? (
          <Box sx={{ p: 1.5, display: "flex", flexDirection: "column", gap: 1.5 }}>
            {Array.from({ length: mobileCardCount }).map((_, i) => (
              <Box
                key={i}
                sx={{ border: `1px solid ${COLORS.slate200}`, borderRadius: 2, p: 2 }}
              >
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
                <Skeleton variant="rounded" width={90} height={22} sx={{ mt: 1 }} />
              </Box>
            ))}
          </Box>
        ) : (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {columns.map((c) => (
                  <TableCell
                    key={c.key ?? c.label}
                    // İskelet sütun genişlikleri gerçek tabloyla aynı olsun ki
                    // yükleme bitince kolonlar yerinden zıplamasın.
                    sx={{ ...listHeadCellSx, ...(c.width ? { width: c.width } : {}) }}
                  >
                    {c.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: rowCount }).map((_, r) => (
                <TableRow key={r}>
                  {columns.map((c) => (
                    <TableCell
                      key={c.key ?? c.label}
                      sx={{ py: 1.25, ...(c.width ? { width: c.width } : {}) }}
                    >
                      <Skeleton variant="text" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Box>

      <ListLoadingOverlay message={message} />
    </Box>
  );
}
